module.exports = __webpack_public_path__ + "static/media/banner.4e86f1b5.png";